export function ServicesPage() {
  return (
    <section className="section container page-intro page-sheet">
      <p className="eyebrow">Services</p>
      <h1 className="page-intro__title">What I can build for you</h1>
      <p className="section__intro page-intro__lede">
        Built for founders who need a professional presence.
      </p>
      <div className="cards">
        <article className="card">
          <div className="card__image">
            <img
              src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80"
              alt="Startup website design example"
              loading="lazy"
            />
          </div>
          <h2 className="card__title">Startup &amp; business sites</h2>
          <p className="card__text">
            Your concept, fully designed and launched.
          </p>
        </article>
        <article className="card">
          <div className="card__image">
            <img
              src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&q=80"
              alt="Landing page on a screen"
              loading="lazy"
            />
          </div>
          <h2 className="card__title">Dashboard</h2>
          <p className="card__text">
            Data, tools and insights - all in one place.
          </p>
        </article>
        <article className="card">
          <div className="card__image">
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80"
              alt="Website refresh and design improvements"
              loading="lazy"
            />
          </div>
          <h2 className="card__title">Revive your website</h2>
          <p className="card__text">
            Optimize and upgrade existing sites - better speed, design, and performance - all around.
          </p>
        </article>
      </div>
    </section>
  );
}
